import * as React from 'react';

import { PaginationSection } from '../../components/Pagination';
import { PaginationButtonsContainer } from './PaginationButtonsContainer';
import { PaginationContainer } from './PaginationNewContainer';

export function PaginationSectionContainer() {
  return <PaginationSection pagination={<PaginationContainer />} buttons={<PaginationButtonsContainer />} />;
}
